export default __webpack_public_path__ + "5cb8e5a59668e0174f9c4c362ccc5603.png";